// extracted by mini-css-extract-plugin
export default {"backdrop":"ModalWindow_backdrop__uHatM","modal":"ModalWindow_modal__oBSLx","slide-down":"ModalWindow_slide-down__XoK31","btn_close":"ModalWindow_btn_close__9cSsV"};